import _ from "lodash";
import {
    ASSIGNMENT__SUBMISSIONS__REQUESTED__SUCCEEDED,
    DROPBOX__USER__SUBMISSIONS__REQUESTED__SUCCEEDED
} from "../constants/actionTypes";

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function submissions(state = INITIAL_STATE, action) {
    switch (action.type) {
        case DROPBOX__USER__SUBMISSIONS__REQUESTED__SUCCEEDED: {
            const { dropbox, submissions, user } = action.payload;

            return {
                ..._.mapKeys(submissions.entities, id),
                dropbox: parseInt(dropbox),
                user: parseInt(user),
            };
        }

        case ASSIGNMENT__SUBMISSIONS__REQUESTED__SUCCEEDED: {
            const { assignment, submissions } = action.payload;

            return {
                ..._.mapKeys(submissions.entities, id),
                assignment: parseInt(assignment),
            };
        }

        default: {
            return state;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/submissionsReducer.js
 **/